import { SVGProps, Ref, forwardRef } from 'react';

export const ForwardFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M.481 4.156c.482-.37 1.16-.045 2.513.605l1.945.936C6.98 6.677 8 7.168 8 8s-1.02 1.322-3.06 2.303l-1.946.935c-1.354.65-2.031.977-2.513.607S0 10.628 0 8.935v-1.87c0-1.693 0-2.539.481-2.909"
                fill="currentColor"
            />
            <path
                d="M8.481 4.156c.482-.37 1.16-.045 2.513.605l1.946.936C14.98 6.677 16 7.168 16 8s-1.02 1.322-3.06 2.303l-1.946.935c-1.354.65-2.031.977-2.513.607S8 10.628 8 8.935v-1.87c0-1.693 0-2.539.481-2.909"
                fill="currentColor"
            />
        </g>
    </svg>
));
ForwardFilledSize16Glyph.displayName = 'ForwardFilledSize16Glyph';
